<template>
  <div>
    <div class="kbx-text-editor"></div>
    <toolbar></toolbar>
  </div>
</template>

<script>
import Toolbar from './toolbar/Main';
import * as editor from 'src/helpers/textEditor';

export default {
  components: {
    Toolbar,
  },
  props: {
    placeholder: String,
    content: String,
    toolbar: Boolean,
    change: Function,
  },
  mounted() {
    this.editorContainer = this.$el.querySelector('.kbx-text-editor');

    this.editor = editor.create({
      placeholder: this.placeholder,
      container: this.$el,
      toolbar: this.toolbar,
      content: this.content,
      onChange: (text) => {
        this.change(text);
      },
    });
  },
  watch: {
    content(value) {
      const range = this.editor.getSelection();
      const editor = this.editorContainer.querySelector('.ql-editor');

      editor.innerHTML = value;

      setTimeout(() => {
        this.editor.setSelection(range);
      }, 1);

      return true;
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?264a951e
 **/